/* eslint-disable */
import { parseUnits } from '@ethersproject/units'
import {
  ButtonMenu,
  ButtonMenuItem,
  CloseIcon,
  Heading,
  IconButton,
  InjectedModalProps,
  ModalBody,
  ModalContainer,
  ModalTitle,
  useMatchBreakpoints,
  Text,
} from '@noahswap/uikit'
import { useWeb3React } from '@noahswap/wagmi'
import { useState, useMemo } from 'react'
import { useTranslation } from '@noahswap/localization'
import styled from 'styled-components'
import { ListLogo } from 'components/Logo'
import { DoubleCurrencyLogo } from 'views/Info/components/CurrencyLogo'
import {
  formatBigNumberToFixed,
  formatFixedNumber,
  truncate,
  truncateZero,
  formatEffectiveNumber,
} from 'utils/formatBalance'
import { ChainLogo } from 'components/Logo/ChainLogo'
import styles from '../style/all.module.scss'
import { Span } from '@sentry/nextjs'

export const ModalHeader = styled.div<{ background?: string }>`
  align-items: center;
  background: transparent;
  display: flex;
  padding: 12px 24px;
`

const SelectBtn = styled.div`
  display: flex;
  padding: 19px;
  font-size: 20px;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  margin-bottom: 10px;
  cursor: pointer;

  &.active {
    border-color: #000;
    background: #ffe169;
  }
`

const AllLPModal: React.FC<React.PropsWithChildren<any>> = ({ onDismiss, item }) => {
  const { isMobile } = useMatchBreakpoints()
  const { t } = useTranslation()
  // console.log('item', item)
  // const handleSetLanguage = (lang) => {
  //   setLanguage(lang)
  //   onDismiss()
  // }

  return (
    <ModalContainer title={t('noah182')} $minWidth={isMobile ? '100%' : '418px'} $minHeight={'auto'}>
      <ModalHeader>
        <ModalTitle>
          {/* <Heading>{t('选择查找的EPOCH')}</Heading> */}
          <div className={`${styles.one} flex flexc flexstart`}>
            {/* <ListLogo logoURI={item.img0} size="30px" />
            <ListLogo logoURI={item.img1} size="30px" style={{ position: 'relative', left: '-6px' }} /> */}
            <DoubleCurrencyLogo token0={item?.token0} token1={item?.token1} size={30} />
            <div className={`flex flexc`} style={{ marginLeft: '30px' }}>
              <div className={`${styles.symbol0Name}`}>
                {item?.symbol0}
                <span className={`${styles.symbol1Name}`}>/{item?.symbol1}</span>
              </div>
            </div>
          </div>
        </ModalTitle>
        <IconButton variant="text" onClick={onDismiss}>
          <CloseIcon width="24px" color="#000" />
        </IconButton>
      </ModalHeader>
      <ModalBody p="0 24px 24px 24px" width="100%">
        <div className={`${styles.list}`}>
          {/* <div className={`${styles.one} flex flexc flexstart`}>
            <ListLogo logoURI={item.img0} size="30px" />
            <ListLogo logoURI={item.img1} size="30px" style={{ position: 'relative', left: '-6px' }} />
            <div className={`flex flexc`}>
              <div className={`${styles.symbol0Name}`}>
                {item.symbol0}
                <span className={`${styles.symbol1Name}`}>/{item.symbol1}</span>
              </div>
            </div>
          </div> */}

          <div className={`${styles.twoBox} flex flexcol`}>
            <div className={`${styles.test} flex flexb`}>
              {/* 手续费分成 */}
              <div className={`${styles.label}`}>{t('noah324')}</div>

              <div className={`${styles.two} flex flexcol flexjc`}>
                {item?.fee_sharing.length > 0 ? (
                  <div>
                    {item?.fee_sharing.map((items, index_fee) => (
                      <div className={``} key={index_fee}>
                        {items?.quantity != 0 ? (
                          <div>
                            {truncateZero(items?.quantity, 4)} {items.symbol}
                          </div>
                        ) : (
                          <div>{index_fee == 0 && <div>-</div>}</div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>-</div>
                )}
              </div>
              {/* {Number(item.threeVal) > 0.01 && (
                <div className={`${styles.two} flex flexcol`}>
                  <div>$ {item.threeVal}</div>
                </div>
              )}
              {Number(item.threeVal) < 0.01 && Number(item.towVal) != 0 && (
                <div className={`${styles.two} flex flexcol`}>
                  <div>$ &lt; 0.01</div>
                </div>
              )}
              {Number(item.threeVal) == 0 && (
                <div className={`${styles.two} flex flexcol`}>
                  <div>$ 0.00</div>
                </div>
              )} */}
            </div>

            <div className={`${styles.test} flex flexb`}>
              {/* 贿赂奖励 */}
              <div className={`${styles.label}`}>{t('noah325')}</div>
              {/* {Number(item.baseRate) > 0 && (
                <div className={`${styles.two} flex flexcol`}>
                  <div>{item.baseRate} ABC</div>
                  <div>{item.heightRate} BCD</div>
                </div>
              )}
              {Number(item.baseRate) <= 0 && (
                <div className={`${styles.two} flex flexcol`}>
                  <div>-</div>
                </div>
              )} */}
              {/* flex flexcol flexjc */}
              <div className={`${styles.two} `}>
                {item?.bribeList.length > 0 ? (
                  <div>
                    {item?.bribeList.map((items, index) => (
                      <div className={``}>
                        <div>
                          {/* {truncateZero(items?.quantity, 4)} {items?.symbol} */}
                          {formatEffectiveNumber(items?.quantity)} {items.symbol}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>-</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </ModalContainer>
  )
}

export default AllLPModal
